import { useEffect, useCallback } from 'react';
import { message } from 'antd';
import { useRequest } from '@wappsto/blanket';
import { Trans } from 'react-i18next';
import { getRequestErrorMessage } from 'util/helpers';
import { METHODS } from 'util/params';
import { useTranslation } from 'translations';

const useClearNotifications = (unreadNotifications, setUnreadNotifications, countRequest) => {
  const { t } = useTranslation('features', 'notifications');
  const { send, request } = useRequest();
  const pending = request?.status === 'pending';

  const clearNotifications = () => {
    if (request?.status === 'pending') {
      return;
    }
    send({
      method: METHODS.delete,
      url: '/notification',
    });
  };

  const updateDeletedNotifications = useCallback(
    (counts, ids) => {
      let count = counts;
      if (ids) {
        ids.forEach((id) => {
          const unreadIndex = countRequest.json?.id?.indexOf(id);
          if (unreadIndex !== -1) {
            count -= 1;
            /* eslint-disable-next-line no-param-reassign */
            countRequest.json.id = [
              ...countRequest.json.id.slice(0, unreadIndex),
              ...countRequest.json.id.slice(unreadIndex + 1),
            ];
          }
        });
      }
      return count;
    },
    [countRequest],
  );

  // update unread count after receiving result
  useEffect(() => {
    if (request) {
      if (request.status === 'success' && request.json) {
        let count = unreadNotifications;
        count = updateDeletedNotifications(count, request.json.deleted);
        count = updateDeletedNotifications(count, request.json.shared_deleted);
        count = updateDeletedNotifications(count, request.json.owned_deleted);
        setUnreadNotifications(count);
      } else if (request.status === 'error') {
        const { message: errorMessage } = getRequestErrorMessage(request, t);
        message.open({
          key: 'notificationsClear',
          type: 'error',
          content: (
            <>
              <Trans t={t} i18nKey="notificationsDeleteError" />
              <div>{errorMessage}</div>
            </>
          ),
        });
      }
    }
  }, [request, setUnreadNotifications, t, unreadNotifications, updateDeletedNotifications]);

  return [clearNotifications, pending] as const;
};

export default useClearNotifications;
